module.exports = __webpack_public_path__ + "static/img/bg_wallet2.9acb3e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wallet/bg_wallet2.png
// module id = u6do
// module chunks = 1